<template>
  <div>
    <!-- search bar -->
    <multi-select
      :options="options"
      :selected-options="newitems"
      placeholder="select item"
      @select="onSelect"
    >
    </multi-select>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary"
          >Vendor Products List</span
        >
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <b-container fluid>
            <b-table
              show-empty
              small
              stacked="md"
              :busy="loading"
              :items="vendorProducts"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <!-- <template v-slot:cell(sr)="data">
                {{ ++sr }}
              </template> -->

              <template v-slot:cell(photo)="data">
                <img
                  :src="getProduct(data.item.productsId, 'image')"
                  height="50px;"
                  weight="50xp;"
                />
              </template>

              <template v-slot:cell(productname)="data">
                {{ getProduct(data.item.productsId, "name") }}
              </template>

              <template v-slot:cell(vendorname)="data">
                {{ getVendor(data.item.vendorId, "shopname") }}
              </template>

              <template v-slot:cell(category)="data">
                {{ getCategory(data.item.productCategoryId, "name") }}
              </template>

              <template v-slot:cell(unittype)="data">
                {{ getProduct(data.item.productsId, "unitType") }}
              </template>

              <template v-slot:cell(price)="data">
                <strong> {{ data.item.sellPrice }}</strong> /
                <del>{{ data.item.mrp }}</del>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge variant="success" v-if="data.item.status == true"
                  >Approve</b-badge
                >
                <b-badge variant="danger" v-else>Disapprove</b-badge>
              </template>

              <template v-slot:cell(action)="data">
                <span v-if="data.item.status == true">
                  <button
                    class="btn btn-sm btn-danger"
                    @click="UpdateVendorProducts(data.item, false)"
                    v-b-tooltip.hover
                    title="Disapprove"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  &nbsp;
                </span>
                <span v-else>
                  <button
                    class="btn btn-sm btn-success"
                    @click="UpdateVendorProducts(data.item, true)"
                    v-b-tooltip.hover
                    title="Approve"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  &nbsp;
                </span>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
            <b-row>
              <b-col sm="4" md="4" lg="4" class="my-1">
                <!-- Testing Pagination -->
                <b-pagination
                  v-model="pagicurrentPage"
                  :total-rows="rows"
                  :per-page="pagiperPage"
                ></b-pagination>

                <p class="mt-3">Current Page: {{ pagicurrentPage }}</p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
import { MultiSelect } from "vue-search-select";

export default {
  data() {
    return {
      flag: 0,
      pagiperPage: 10,
      pagicurrentPage: 1,
      vendorProductCopy: [],
      overallproductsofvendor: [],
      overallproducts: [],
      newitems: [],
      searchText: "",
      lastSelectItem: {},
      index: 0,
      options: [],
      loading: false,
      dataTable: null,
      addProductloading: false,
      loadingType: "loading",
      loadingMessage: "Uploading",
      vendorProducts: [],
      products: [],
      vendors: [],
      unitlist: [
        {
          value: null,
          text: "Select Unit"
        },
        {
          value: "Kilogram",
          text: "Kilogram"
        },
        {
          value: "Gram",
          text: "Gram"
        },
        {
          value: "Milliliter",
          text: "Milliliter"
        },
        {
          value: "Liter",
          text: "Liters"
        },
        {
          value: "Pcs",
          text: "Pcs"
        }
      ],
      fields: [
        {
          key: "sr",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "vendorname",
          label: "Vendor Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "photo",
          label: "Photo",
          class: "text-center"
        },
        {
          key: "productname",
          label: "Products Name",
          class: "text-center"
        },
        {
          key: "category",
          label: "Products Category",
          class: "text-center"
        },
        {
          key: "unittype",
          label: "Unit Type",
          sortable: false,
          class: "text-center"
        },
        {
          key: "stock",
          label: "Stock",
          sortable: true,
          class: "text-center"
        },
        {
          key: "price",
          label: "Price",
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "text-center"
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
          class: "text-center"
        }
      ],
      items: [],
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: []
    };
  },
  computed: {
    rows() {
      return this.overallproductsofvendor.length;
    }
  },
  mounted() {
    this.setupFirebaseReading();
    this.getnames();
    this.allVendorProducts();
    this.allproducts();
    this.getCategoryData();
    this.getProductsData();
    this.getVendorsData();
  },
  methods: {
    setupFirebaseReading: function() {
      var count1 = 0;
      this.loading = true;
      dbFs
        .collection("vendorProducts")
        // .orderBy("productsId")
        // .startAt(1)
        // .endAt(10)
        .limit(10)
        .get()
        .then(res => {
          res.forEach(doc => {
            let data = doc.data();
            this.vendorProducts.push({
              id: doc.id,
              moq: data.moq,
              mrp: data.mrp,
              productCategoryId: data.productCategoryId,
              productsId: data.productsId,
              sellPrice: data.sellPrice,
              status: data.status,
              stock: data.stock,
              vendorId: data.vendorId
            });
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.vendorProductCopy = this.vendorProducts;
          this.vendorProducts.forEach(doc => {
            doc["sr"] = ++count1;
          });
        });
    },
    getnames() {
      this.loading = true;
      let count = 0;
      dbFs
        .collection("products")
        .get()
        .then(res => {
          res.forEach(doc => {
            var obj = {
              value: ++count,
              text: doc.data().name
            };
            this.options.push(obj);
          });
        });
    },
    allVendorProducts() {
      var count1 = 0;
      this.loading = true;
      dbFs
        .collection("vendorProducts")
        .get()
        .then(res => {
          res.forEach(doc => {
            let data = doc.data();
            this.overallproductsofvendor.push({
              id: doc.id,
              moq: data.moq,
              mrp: data.mrp,
              productCategoryId: data.productCategoryId,
              productsId: data.productsId,
              sellPrice: data.sellPrice,
              status: data.status,
              stock: data.stock,
              vendorId: data.vendorId
            });
          });
          this.overallproductsofvendor.forEach(doc => {
            doc["sr"] = ++count1;
          });
        });
    },
    allproducts() {
      this.loading = true;
      this.$bind("overallproducts", dbFs.collection("products"));
    },
    getCategoryData() {
      this.loading = true;
      this.$bind("category", dbFs.collection("productCategory"))
        .then(() => {
          this.categorylist.push({
            value: null,
            text: "Select Category"
          });
          for (let index = 0; index < this.category.length; index++) {
            this.categorylist.push({
              value: this.category[index].categoryId,
              text: this.category[index].name
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductsData() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVendorsData() {
      this.loading = true;
      this.$bind("vendors", dbFs.collection("vendor"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCategory(id, dataType) {
      let categoryDetails = "";
      for (const cusKey of Object.keys(this.category)) {
        const category = this.category[cusKey];
        if (id == category.id) {
          categoryDetails = category;
        }
      }
      if (dataType == "name") {
        return categoryDetails.name;
      }
      if (dataType == "image") {
        return categoryDetails.img;
      }
    },
    getProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendor(id, dataType) {
      let VendorDetails = "";
      for (const cusKey of Object.keys(this.vendors)) {
        const vendor = this.vendors[cusKey];
        if (id == vendor.id) {
          VendorDetails = vendor;
        }
      }
      if (dataType == "shopname") {
        if (VendorDetails.shopDetails) {
          return VendorDetails.shopDetails.name;
        }
      }
      if (dataType == "ownername") {
        return VendorDetails.personalDetails.name;
      }
      if (dataType == "address") {
        let address = `${VendorDetails.shopDetails.address.firstLine},
        ${VendorDetails.shopDetails.address.city},
        ${VendorDetails.shopDetails.address.state},
        ${VendorDetails.shopDetails.address.pincode}`;
        return address;
      }
    },
    UpdateVendorProducts(product, status) {
      let id = product.id;
      dbFs
        .collection("vendorProducts")
        .doc(id)
        .update({
          status: status
        })
        .then(() => {
          console.log("Update");
        })
        .finally(() => {
          this.overallproductsofvendor.forEach(doc => {
            if (doc.id === id) {
              doc.status = status;
            }
          });
          this.vendorProducts.forEach(doc => {
            if (doc.id === id) {
              doc.status = status;
            }
          });
        });
    },
    onSelect(items, lastSelectItem) {
      if (items.length != 0) {
        this.newitems = items;
        this.lastSelectItem = lastSelectItem;
        var x = [];
        this.newitems.forEach(ele => {
          var prodid = "";
          this.overallproducts.forEach(doc => {
            if (ele.text === doc.name) {
              prodid = doc.productId;
            }
          });
          this.overallproductsofvendor.forEach(doc => {
            if (prodid === doc.productsId) {
              x.push(doc);
            }
          });
        });
        this.vendorProducts = x;
      } else {
        this.newitems = items;
        this.lastSelectItem = lastSelectItem;
        this.vendorProducts = this.vendorProductCopy;
      }
    }
  },
  components: {
    MultiSelect
  },
  watch: {
    pagicurrentPage(newValue) {
      this.vendorProducts = [];
      var indexstart = (newValue - 1) * 10;
      var indexend = indexstart + 9;
      for (var x = indexstart; x <= indexend; x++) {
        if (this.overallproductsofvendor[x]) {
          this.vendorProducts.push(this.overallproductsofvendor[x]);
        }
      }
    }
  }
};
</script>

<style scoped></style>
